// Copyright ©️ 2026 eVolve MEP, LLC

import { type WorkCellTaskType, useEvolveDelete } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';

import type { ModalRegistryManagedProps } from 'components/Mantine/Modals/createModalRegistry';
import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';

type Props = ModalRegistryManagedProps & {
  workCellTaskType: WorkCellTaskType;
  onWorkCellTaskTypeUnassigned: () => void;
};

export const UnassignTaskTypeModal = ({ workCellTaskType, onWorkCellTaskTypeUnassigned, ...props }: Props) => {
  const { apiCall: unassignWorkCellTaskTypeApiCall } = useEvolveDelete(
    `shop/workCellTaskType/${workCellTaskType.workCellTaskTypeId}`,
  );
  return (
    <WrappedModal
      title="Unassign task type"
      confirmationText="Unassign"
      buttonColor="red"
      onConfirm={async () => {
        await unassignWorkCellTaskTypeApiCall();
        onWorkCellTaskTypeUnassigned();
      }}
      {...props}
    >
      <Text>
        Are you sure you want to unassign <b>{workCellTaskType.taskTypeName}</b>?
      </Text>
    </WrappedModal>
  );
};
